import { render, staticRenderFns } from "./AdminInit.vue?vue&type=template&id=31581698&"
import script from "./AdminInit.vue?vue&type=script&lang=js&"
export * from "./AdminInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports